import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

export const News = styled.div`
  border-radius: 1rem;
  border: 1px solid ${nuDSColor('black', 'defaultT10')};
  padding: 1.25rem;
  margin-top: 1.5rem;
  display: flex;
`;

News.displayName = 'News';
